<template>
  <div id="24_vtps">
    <v-row>
      <v-alert v-show="errorAlertShow" dense outlined type="error"><strong>Критична помилка! </strong>( {{errorMessage}} )</v-alert>
      <v-progress-linear v-show="progresLineShow" indeterminate fixed color="red"></v-progress-linear>
    </v-row>


    <v-row >
      <v-col cols="12" sm="6" md="3">        
        <v-menu
          v-model="PMenuPicker"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="PDate"
              label="Починаючи з:"
              prepend-icon="event"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="PDate" locale="uk" :first-day-of-week="1" @input="chPDate()"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="3">        
        <v-menu
          v-model="KMenuPicker"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="KDate"
              label="Закінчуючі:"
              prepend-icon="event"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="KDate" locale="uk" :first-day-of-week="1" @input="chKDate()"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-select
          v-model="skladSelect"
          :items="skladsList"
          dense
          label="Склад"
          attach
          single-line
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-btn v-show="sendBtnShow" @click="getZvit()"
          color="primary"
          elevation="2"
          outlined
        >Сформувати</v-btn>
        <v-btn v-show="sendBtnShow" @click="printZvit()"
          color="primary"
          elevation="2"
          outlined
        ><v-icon class="mr-2">mdi-printer</v-icon></v-btn>
      </v-col>
    </v-row>
    <v-simple-table dense>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">article</th>
          <th class="text-left">name</th>
          <th class="text-left">{{PDate}}</th>
          <th class="text-left">Надходження</th>
          <th class="text-left">Видаток</th>
          <th class="text-left">{{KDate}}</th>

        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in tmclist"
          :key="item.id"
        >
          <td>{{ item.article }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.pzal }}</td>
          <td>{{ item.plus }}</td>
          <td>{{ item.minus }}</td>
          <td>{{ item.kzal }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>

  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        errorMessage: '',
        errorAlertShow: false,
        progresLineShow: false,
        PDate: '',
        PMenuPicker: false,
        KDate: '',
        KMenuPicker: false,
        skladsList: [],
        skladSelect: '',
        tmclist: [],
        
      }
    },
    watch: {
      
    },
    methods: { 
      getSkladsList () {
        this.progresLineShow = true
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            act: '24',
            ww: '1',
            pp: localStorage.pp,
            pn: localStorage.pn,
          })
        };
        fetch(this.$store.getters.apiUrl, requestOptions)
        .then((data) => {
          if (!data.ok) {
            const error = (data && data.message) || data.status
            return Promise.reject(error)
          }
          return data
        })
        .then((data) => data.json())
        .then((data) => {
          if (data.isauth == true) {
            this.progresLineShow = false
            this.skladsList = data.skladslist
            this.PDate = data.PDate
            this.KDate = data.KDate
          }
          if (data.isauth == false) {
            this.$router.push('/login').catch(()=>{})
          }
        })
        .catch(error => {
          this.errorMessage = error
          this.progresLineShow = false
          this.errorAlertShow = true
        });
      },
      getZvit () {
        this.progresLineShow = true
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            act: '24',
            ww: '2',
            PDate: this.PDate,
            KDate: this.KDate,
            pp: localStorage.pp,
            pn: localStorage.pn,
            sklad: this.skladSelect,
          })
        };
        fetch(this.$store.getters.apiUrl, requestOptions)
        .then((data) => {
          if (!data.ok) {
            const error = (data && data.message) || data.status
            return Promise.reject(error)
          }
          return data
        })
        .then((data) => data.json())
        .then((data) => {
          if (data.isauth == true) {
            this.progresLineShow = false
            this.tmclist = data.tmclist
            this.PDate = data.PDate
            this.KDate = data.KDate
          }
          if (data.isauth == false) {
            this.$router.push('/login').catch(()=>{})
          }
        })
        .catch(error => {
          this.errorMessage = error
          this.progresLineShow = false
          this.errorAlertShow = true
        });
      },
      chPDate () {
        this.PMenuPicker = false
      },
      chKDate () {
        this.KMenuPicker = false
      },
      printZvit: function () {
        window.open(this.$store.getters.apiUrl+"pdf/?ww=24-2&pp="+localStorage.pp+"&pn="+localStorage.pn+"&pd="+this.PDate+"&kd="+this.KDate+"&s="+this.skladSelect, "_blank")
      },

    },
    computed: {
      sendBtnShow: function () {
        if (this.skladSelect.length > 0 
          && this.PDate.length > 0 
          && this.KDate.length > 0
          ) {
          return true
        } 
        else return false
      },
      
    },
    created: function () {
      this.getSkladsList()
    },
  }
</script>